import { EmptyState } from '@/components/common/EmptyState'
import { Button } from '@teach/ui'
import emptyCatalogImage from '@/assets/empty-catalog.png'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  hasActiveFilters: boolean
  /** Находка 3: есть ли снимаемые чипы (поиск/категории/сложность/«чужой»
   *  язык). Когда их нет, а выдачу всё равно сузил implicit языковой фильтр
   *  (языку интерфейса ещё нет курсов), «Сбросить фильтры» нечего сбрасывать
   *  в URL — единственное осмысленное действие «Показать все языки». */
  hasRemovableChips: boolean
  onReset: () => void
  onShowAllLanguages: () => void
}

/** items.length === 0 branch of CatalogResults, split out to keep the file
 *  under the line-count gate. Two distinct empty states: an active filter
 *  (incl. languageFilter !== 'all', which is ALWAYS sent to the backend)
 *  narrowed the result to zero, vs. the platform genuinely has no courses. */
export const CatalogEmptyResults = ({
  hasActiveFilters,
  hasRemovableChips,
  onReset,
  onShowAllLanguages,
}: Props) => {
  const m = useMessages(messages)
  if (hasActiveFilters) {
    return (
      <EmptyState
        title={m.nothingFound}
        description={m.nothingFoundHint}
        action={
          <div className="flex flex-wrap items-center justify-center gap-2">
            {hasRemovableChips ? (
              <Button onClick={onReset}>{m.resetFilters}</Button>
            ) : (
              <Button onClick={onShowAllLanguages}>{m.showAllLanguages}</Button>
            )}
          </div>
        }
      />
    )
  }

  return (
    <div className="flex flex-col items-center justify-center h-[60vh] text-center">
      <img src={emptyCatalogImage} alt="No courses" className="w-32 h-32 mb-6 object-contain" />
      <h3 className="text-lg font-medium text-foreground/80 mb-2">{m.noPublicCourses}</h3>
      <p className="text-sm text-foreground/40 max-w-sm">{m.noPublicCoursesHint}</p>
    </div>
  )
}
